const types = {
  SET_STRINGS: 'SET_STRINGS',
  SET_LANGUAGE: 'SET_LANGUAGE',
  LOADING_LANGUAGE: 'LOADING_LANGUAGE',
}

export default types;